export default __webpack_public_path__ + "static/1-fe82ad26bf1c097961074b415a017d3e.png";